import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { fade, fadeTop, textsFromBottom, textsFromLeft, effectCounter } from './imports/animations.js';
import { MenuReveal } from './imports/animations.js';
gsap.registerPlugin(ScrollTrigger);
gsap.registerEffect(effectCounter);

export default {
  data() {
    return {
      mobileMenuReveal: null
    }
  },
  methods: {
    animateHeading() {
      document.querySelector(".page-heading").classList.add("active");
    },
    animateFooter() {
      document.querySelector(".footer").classList.add("active");
    },
    startAnimations() {
      this.animateFooter();

      setTimeout(() => {
        if (document.querySelector(".texts-from-bottom")) {
          textsFromBottom();
        }

        if (document.querySelector(".texts-from-left")) {
          textsFromLeft();
        }

        if (document.querySelector(".els-fade")) {
          fade();
        }

        if (document.querySelector(".els-fade-top")) {
          fadeTop(true);
        }

      }, 350);
    },
    revealLinks() {      
      console.log('revealLinks')
      this.mobileMenuReveal.reveal();
    },
    hideLinks() {      
      console.log('hideLinks')
      this.mobileMenuReveal.reset();
    },
  },
  mounted() {
    this.mobileMenuReveal = new MenuReveal;

    if (document.querySelector(".page-heading")) {
      setTimeout(() => {
        this.animateHeading();
      }, 500);
    }

    ///////////////////////////////////////////////////// Parallax
    gsap.utils.toArray("[data-parallax]").forEach(element => {
      gsap.to(element, {
        scrollTrigger: {
          scrub: 2,
          // invalidateOnRefresh: true
        },
        yPercent: (i, target) => element.dataset.parallax,
        ease: "none"
      });
    });

    ///////////////////////////////////////////////////// About
    const fixedBgs = gsap.utils.toArray(".fixed-bg");

    if (fixedBgs.length) {
      ScrollTrigger.create({
        // markers: true,
        trigger: "#bg-2",
        start: "0% 50%",
        end: "100% 50%",
        onToggle: (self) => {
          fixedBgs.forEach(bg => {
            bg.classList.remove('active');
          });

          if (self.isActive) {
            fixedBgs[1].classList.add('active');
          } else {
            fixedBgs[0].classList.add('active');
          }
        },
      });
    }

    ///////////////////////////////////////////////////// Counters
    const counters = document.querySelectorAll("[data-counter]");

    if (counters.length) {
      counters.forEach(counter => {
        const counterEnd = counter.getAttribute("data-counter");

        gsap.timeline({
          scrollTrigger: {
            trigger: counter,
            start: "0% 100%",
            end: "0% 100%",
            toggleActions: 'play none none none',
            // markers: true,
            // onEnter: () => {
            //   console.log("on enter");
            // }
          }
        }).counter(counter, { end: counterEnd, duration: 3, ease: "linear" });
      });
    }

    ///////////////////////////////////////////////////// Fleet counter lines
    const linesHorizontal = document.querySelectorAll(".line-horizontal span");
    const linesVertical = document.querySelectorAll(".line-vertical span");

    if (linesHorizontal.length) {
      linesHorizontal.forEach(line => {
        gsap.to(line, {
          scrollTrigger: {
            trigger: ".fleet-counters",
            start: "top 70%",
            end: "top 70%",
            toggleActions: "play none reverse none",
            // markers: true
          },
          width: '100%',
          duration: 1,
        });
      });
    }

    if (linesVertical.length) {
      linesVertical.forEach(line => {
        gsap.to(line, {
          scrollTrigger: {
            trigger: ".fleet-counters",
            start: "top 70%",
            end: "top 70%",
            toggleActions: "play none reverse none",
            // markers: true
          },
          height: '100%',
          duration: 1,
        });
      });
    }

    // gsap.to('.news-featured li', {
    //   scrollTrigger: {
    //     trigger: ".news-featured",
    //     start: "0% 80%",
    //     end: "0% 80%",
    //     toggleActions: 'play none reverse none',
    //   },
    //   duration: 1.25,
    //   width: '100%',
    //   stagger: 0.1
    // });
  }
}